module.exports = __webpack_public_path__ + "static/media/SCG_Chem.ae2e8cea.png";